import { render, staticRenderFns } from "./ActivationBriefAffiliateLinksProvider.vue?vue&type=template&id=7e10386a&scoped=true&"
import script from "./ActivationBriefAffiliateLinksProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAffiliateLinksProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10386a",
  null
  
)

export default component.exports